import config from '../const/config';
var getFlagsAssetURL = function () {
    var flagsPath = 'digital-collections-mfe/collections-config.json';
    var nonprodAssetsHost = 'https://dev.synchronycredit.com/assets/';
    var useMockFlags = sessionStorage.getItem('dc-mfe__selected-client') === 'mockData';
    var assetsHost = useMockFlags ? nonprodAssetsHost : config.FEATURE_FLAG_URL;
    return "".concat(assetsHost).concat(flagsPath);
};
export default getFlagsAssetURL;
//# sourceMappingURL=getFlagsAssetURL.js.map